import { Scenarios } from '@jfs/network'

const executeTransaction = {
  default: [
    {
      url: /payouts\/transaction/,
      method: 'POST',
      body: /"type":312/,
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          transaction: { transactionTime: 'Fri Jan 28 16:26:31 IST 2022', transactionId: '10672202859191877000' },
          account: { balance: '50000.0', accountExist: true },
        },
      },
      delay: 500,
    },
    {
      url: /payouts\/transaction/,
      method: 'POST',
      body: /"type":424/,
      response: {
        responseCode: '076',
        responseMessage: 'FAILED',
        responseData: {
          transaction: {
            transactionTime: 'Fri Jan 28 16:26:31 IST 2022',
            transactionId: '10672202859191877000',
            rrn: '4587356487',
          },
          account: { balance: '50000.0', accountExist: true },
        },
      },
      delay: 500,
    },
    {
      url: /payouts\/transaction/,
      method: 'POST',
      body: /"type":217/,
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          transaction: {
            transactionTime: 'Fri Jan 28 16:26:31 IST 2022',
            transactionId: '10672202859191877000',
            rrn: '4587356487',
          },
          account: { balance: '50000.0', accountExist: true },
        },
      },
      delay: 500,
    },
    {
      url: /payouts\/transaction/,
      method: 'POST',
      body: /"type":115/,
      response: {
        responseCode: '07',
        responseMessage: 'FAILED',
        responseData: {
          transaction: { transactionTime: 'Fri Jan 28 16:26:31 IST 2022', transactionId: '10672202859191877000' },
          account: { balance: '50000.0', accountExist: true },
        },
      },
      delay: 500,
    },
    {
      url: /payouts\/transaction/,
      method: 'POST',
      body: /"type":311/,
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          transaction: {
            transactionTime: 'Fri Mar 25 18:39:46 IST 2022',
            rrn: '400671844620',
            transactionId: '10002208467184461000',
          },
          account: {
            balance: '11096.8',
          },
          miniStatement: [
            {
              transactionType: 'XXXX',
              transactionTime: '',
              amount: '0',
              transactionDetails: '220912DR UPIOUT/2255875000000011500',
              transactionId: '',
            },
            {
              transactionType: 'XXXX',
              transactionTime: '',
              amount: '0',
              transactionDetails:
                '220912DR UPIOUT/2255875000000011500 220912DR UPIOUT/2255875000000011500220912DR UPIOUT/2255875000000011500220912DR UPIOUT/2255875000000011500220912DR UPIOUT/2255875000000011500220912DR UPIOUT/2255875000000011500',
              transactionId: '',
            },
            {
              transactionType: 'Debit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OnUs Fund Transfer RRN: 30168143271',
              transactionId: '',
            },
            {
              transactionType: 'XXXX',
              transactionTime: '',
              amount: '0',
              transactionDetails: '220912D',
              transactionId: '',
            },
            {
              transactionType: 'Debit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OffUs Fund Transfer RRN: 3015822516',
              transactionId: '',
            },
            {
              transactionType: 'Credit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OnUs Fund Transfer RRN: 30158221170',
              transactionId: '',
            },
            {
              transactionType: 'Debit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OnUs Fund Transfer RRN: 30158221170',
              transactionId: '',
            },
            {
              transactionType: 'Debit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OnUs Withdrawal RRN: 301582182671',
              transactionId: '',
            },

            {
              transactionType: 'Debit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OffUs Fund Transfer RRN: 3015796243',
              transactionId: '',
            },
            {
              transactionType: 'Credit',
              transactionTime: '14072021',
              amount: '1.00',
              transactionDetails: 'AePS OnUs Fund Transfer RRN: 30157959258',
              transactionId: '',
            },
          ],
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /payouts\/transaction/,
      method: 'POST',
      responseCode: 500,
      response: { responseCode: '22413', message: 'Please verify provided data.' },
      delay: 1000,
    },
  ],
} as Scenarios

export { executeTransaction }
